import { z } from 'zod';

import { chatUiBase } from '../../shared/schema/base.js';

/**
 * Os atalhos determinísticos que o card oferece. Fechado de propósito: cada
 * chave tem UMA ilustração (o `GuidedFlowCards` do intelligence-ui-kit) e UM destino no app
 * produto, então um valor novo é uma mudança de contrato (arte + rota), nunca
 * string livre. O handoff do DS traz trem; o produto não vende trem — vende
 * ônibus.
 */
export const GuidedFlowSchema = z.enum(['flight', 'hotel', 'rental', 'bus']);
export type GuidedFlow = z.infer<typeof GuidedFlowSchema>;

/**
 * `guided_flows` — os atalhos ilustrados de reserva manual (handoff
 * "GuidedFlowCards"), o atalho determinístico da conversa: em vez de o agente
 * ENUMERAR os serviços em prosa, o cliente vê os quatro cards e toca. Sem
 * challenge no wire — o toque manda uma mensagem carregando o domínio escolhido
 * (`domainHint`), e o supervisor entra direto no subgrafo dele.
 *
 * `label` nulo = o card usa a própria copy localizada.
 *
 * `traveler` é o DADO do pedido para outra pessoa (#2952), não a frase pronta:
 * quem renderiza escolhe a copy no idioma de quem lê, tanto do convite quanto do
 * texto que o toque manda. Ausente = a conversa é sobre a viagem do próprio
 * cliente (o caso de sempre), então o histórico antigo continua válido.
 */
export const GuidedFlowsBlockSchema = z
  .object({
    ...chatUiBase,
    kind: z.literal('guided_flows'),
    label: z.string().min(1).max(120).nullable(),
    traveler: z.string().min(1).max(80).nullish(),
    // Conjunto, não lista: um serviço repetido renderizaria dois cards idênticos.
    // Mesma régua dos ids únicos do `ChatUiMessageSchema` — o contrato de wire
    // recusa o payload em vez de deixar o render decidir.
    flows: z
      .array(GuidedFlowSchema)
      .min(1)
      .max(4)
      .refine((flows) => new Set(flows).size === flows.length, {
        message: 'flows: atalho repetido',
      }),
  })
  .strict();
export type ChatUiGuidedFlows = z.infer<typeof GuidedFlowsBlockSchema>;
